import {
  today,
  firstDateOfMonth,
  lastDateOfMonth,
  startLastMonth,
  endLastMonth,
  startThisWeek,
  endThisWeek,
  startLastWeek,
  endLastWeek,
  last7,
} from '@/store/helpers'
import moment from 'moment'

export const formatMonthText = val => {
  if (!val) return 'Bulan Ini'
  const momentVal = moment(val)
  const isThisMonth = momentVal.isSame(moment(), 'month')
  return isThisMonth ? 'Bulan Ini' : momentVal.format('MMM YYYY')
}

export const formatShortNumber = num => {
  if (!num) return '0'
  if (num >= 1000000) return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`
  if (num >= 1000) return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`
  return Number(num).toLocaleString('id-ID')
}

export const fieldsPartnerTable = [
  {
    key: 'name',
    label: 'Nama Partner',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'subscription',
    label: 'Subscription',
    thClass: 'font-bold capitalize text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'partner_phone',
    label: 'Nomor Pelanggan',
    thClass: 'font-bold capitalize text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'join_date',
    label: 'Tanggal Bergabung',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'last_active',
    label: 'Status',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'action',
    label: '',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]

export const optionsFilter = [
  {
    label: 'Semua',
    value: {
      startDate: new Date(2000, 0, 1),
      endDate: today,
    },
  },
  {
    label: 'Bulan ini',
    value: {
      startDate: firstDateOfMonth,
      endDate: lastDateOfMonth,
    },
  },
  {
    label: 'Bulan lalu',
    value: {
      startDate: startLastMonth,
      endDate: endLastMonth,
    },
  },
  {
    label: 'Minggu ini',
    value: {
      startDate: startThisWeek,
      endDate: endThisWeek,
    },
  },
  {
    label: 'Minggu lalu',
    value: {
      startDate: startLastWeek,
      endDate: endLastWeek,
    },
  },
  {
    label: 'Date Picker',
    value: {
      startDate: '',
      endDate: '',
    },
  },
]

export const revenueFilter = [
  {
    label: 'All Revenue',
    value: 'all_revenue',
  },
  {
    label: 'Subscription',
    value: 'subscription',
  },
  {
    label: 'Closing Order',
    value: 'closing_order',
  },
  {
    label: 'Broadcast',
    value: 'broadcast',
  },
]

export const status = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
  {
    label: 'Expired',
    value: 'expired',
  },
]

export const typeProduct = [
  {
    label: 'Komchat Starter',
    value: 'starter',
  },
  {
    label: 'Komchat Basic',
    value: 'basic',
  },
  {
    label: 'Komchat Pro',
    value: 'pro',
  },
]

export const typeServices = [
  {
    label: 'Komchat AI',
    value: 'komchat_ai',
  },
  {
    label: 'Komchat for Brands',
    value: 'komchat_brand',
  },
]

export const rangesDate = {
  'Hari ini': [today, today],
  '7 Hari Terakhir': [last7, today],
  'Bulan ini': [firstDateOfMonth, lastDateOfMonth],
  'Bulan lalu': [startLastMonth, endLastMonth],
  'Custom Range': [null, null],
}

export const revenueChartOptions = {
  chart: {
    type: 'area',
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  noData: {
    text: 'Tidak ada data yang ditampilkan',
    align: 'center',
    verticalAlign: 'middle',
    style: {
      color: '#9CA3AF',
      fontSize: '14px',
    },
  },
  colors: ['#EF4444', '#F59E0B', '#10B981'],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2,
  },
  fill: {
    type: 'gradient',
    gradient: {
      opacityFrom: 0.6,
      opacityTo: 0.1,
    },
  },
  xaxis: {
    categories: [],
    labels: {
      rotate: 0,
      rotateAlways: false,
      hideOverlappingLabels: true,
      formatter: value => {
        const date = new Date(value)
        return Number.isNaN(date.getTime()) ? value : date.getDate()
      },
      style: {
        colors: '#9CA3AF',
        fontSize: '12px',
      },
    },
  },
  yaxis: {
    min: 0,
    tickAmount: 5,
    labels: {
      formatter: value => {
        if (value >= 1000000) {
          return `${(value / 1000000).toFixed(1)} Jt`
        }
        if (value >= 1000) {
          return `${(value / 1000).toFixed(1)} Rb`
        }
        return `${value}`
      },
      style: {
        colors: '#9CA3AF',
        fontSize: '12px',
      },
    },
  },
  legend: {
    show: false,
  },
  grid: {
    borderColor: '#E5E7EB',
    strokeDashArray: 4,
    xaxis: {
      lines: { show: false },
    },
    yaxis: {
      lines: { show: true },
    },
  },
  tooltip: {
    shared: true,
    intersect: false,
    x: {
      formatter: (value, opts) => {
        const categories = opts && opts.w && opts.w.config && opts.w.config.xaxis && opts.w.config.xaxis.categories
        const raw = categories && categories[opts.dataPointIndex]
        const iso = typeof raw === 'string' && raw.includes('-') ? raw : null
        if (!iso) return value
        const parts = iso.split('-').map(Number)
        if (parts.length !== 3 || parts.some(Number.isNaN)) return value
        const [year, month, day] = parts
        return new Date(year, month - 1, day).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })
      },
    },
    y: {
      formatter: value => {
        const formatted = new Intl.NumberFormat('id-ID').format(value)
        return `Rp${formatted}`
      },
    },
  },
}

export const fieldsClosingOrder = [
  {
    key: 'name', label: 'Nama Partner', thClass: 'text-left text-black font-semibold border-0 ', tdClass: ' border-b border-gray-100 align-middle',
  },
  {
    key: 'nominal', label: 'Nominal Transaksi', thClass: 'text-left text-black font-semibold border-0 ', tdClass: ' border-b border-gray-100 align-middle text-black',
  },
  {
    key: 'jumlah', label: 'Jumlah Closing', thClass: 'text-left text-black font-semibold border-0 ', tdClass: ' border-b border-gray-100 align-middle text-black',
  },
  {
    key: 'action', label: '', thClass: 'border-0 ', tdClass: ' border-b border-gray-100 align-middle text-right',
  },
]

export const fieldsDataAgent = [
  {
    key: 'partner_name', label: 'Nama Partner', thClass: 'text-left text-black font-semibold border-0 w-3/12', tdClass: ' border-b border-gray-100 align-middle',
  },
  {
    key: 'agent_name', label: 'Nama Agent', thClass: 'text-left text-black font-semibold border-0 w-3/12', tdClass: ' border-b border-gray-100 align-middle text-black',
  },
  {
    key: 'agent_phone', label: 'Nomor Agent', thClass: 'text-left text-black font-semibold border-0 w-3/12', tdClass: ' border-b border-gray-100 align-middle text-black',
  },
  {
    key: 'status', label: 'Status', thClass: 'text-left text-black font-semibold border-0 w-3/12', tdClass: ' border-b border-gray-100 align-middle',
  },
]
